export default __webpack_public_path__ + "static/media/028-gold medal.562d95cd.svg";